"use strict";
/**************************************************************************************************
 *
 *       @file ./request-callback.ts
 *
 *       Callback object for handling sync request (HTTP request).
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var javelin_exports_1 = require("../../javelin-exports");
var RequestCallback = /** @class */ (function () {
    function RequestCallback(cbs) {
        // May not be needed, but may have unexpected purpose later
        this.$metadata$ = javelin_exports_1.javelin.sync.model.RequestCallback.$metadata$;
        this.onSuccess = cbs.onSuccess;
        this.onError = cbs.onError;
    }
    return RequestCallback;
}());
exports.RequestCallback = RequestCallback;
//# sourceMappingURL=request-callback.js.map